<script lang="ts" setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import BlogForm from "@/components/blog/BlogForm.vue";

const store = useStore();
const route = useRoute();

onMounted(() => {
  if (route.params.id) {
    store.dispatch(Actions.GetBlog, route.params.id);
  }
});
</script>
<template><BlogForm></BlogForm></template>
